import React from 'react'
import styled from 'react-emotion'
import { Button, color } from 'stylist'

const ModalButton = ({ show, ...rest }) => (
  <Button kind={'standard'} onClick={show} dark {...rest}>
    Import
  </Button>
)

export default styled(ModalButton)`
  display: inline-block;
  float: right;
  height: 40px;
  font-size: 14px;

  color: ${color('white')};
  &:hover {
    opacity: 0.8;
  }
`



// WEBPACK FOOTER //
// ./src/components/Editor/ConfirmationModal/TriggerButton.js